module.exports = __webpack_public_path__ + "static/media/YourStoryOurStory-411x93px.d8170884.webp";